import { BaseButton, BatchDocumentUploadDialog, ProviderCreateDocumentType } from '@enter/core';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { IInjectedRootStore } from '../../stores';
import * as S from './document-upload-dialog.styles';

interface IDocumentUploadDialogProps extends IInjectedRootStore {
    onClose: () => void;
    onUploaded?: () => Promise<void> | void;
}

const DOCUMENT_TYPES: {
    value: ProviderCreateDocumentType;
    label: string;
    info: string;
}[] = [
    {
        value: ProviderCreateDocumentType.AICLAIM,
        label: 'Claim',
        info: ' - A single encounter including patient demographics, insurance, rendered procedures, and prior authorizations used in the manual creation of a claim.',
    },
    {
        value: ProviderCreateDocumentType.AIFAX,
        label: 'Fax',
        info: ' - A scanned fax received by the practice to be sorted and posted to claims.',
    },
    {
        value: ProviderCreateDocumentType.AIMAIL,
        label: 'Mail',
        info: ' - A scanned letter received by the practice mailbox to be sorted and posted to claims.',
    },
];

export const DocumentUploadDialog: React.FunctionComponent<IDocumentUploadDialogProps> = inject('rootStore')(
    observer((props: IDocumentUploadDialogProps): React.ReactElement => {
        const { rootStore, onClose, onUploaded } = props;

        if (!rootStore) {
            return <></>;
        }

        if (rootStore.isDemo()) {
            return (
                <S.DialogBody>
                    <S.Description>Document uploads are not available in demo mode.</S.Description>
                    <S.Actions>
                        <BaseButton variant="outlined" onClick={onClose}>
                            Close
                        </BaseButton>
                    </S.Actions>
                </S.DialogBody>
            );
        }

        const handleComplete = async (uploadedIds: string[]): Promise<void> => {
            if (uploadedIds.length > 0) {
                await onUploaded?.();
            }
        };

        return (
            <BatchDocumentUploadDialog
                appType="provider"
                batchUploadStore={rootStore.batchUploadStore}
                documentTypeOptions={DOCUMENT_TYPES}
                onClose={onClose}
                onComplete={handleComplete}
            />
        );
    }),
);
